import { DisplayMode } from 'cbc-shared-lib';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, UntypedFormArray, FormGroup, Validators } from '@angular/forms';
import { SlideadjustmentunitpriceBasicInfo, SlideadjustmentunitpriceInfo, SlidecalculationelementsInfoDto } from 'sg-api';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * スライド調整単価登録画面(単価情報)
 * @exports
 * @class Sgkc032dSlideTankaTankaInfoComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc032d-slide-tanka-tanka-info',
    templateUrl: './sgkc032d-slide-tanka-tanka-info.component.html',
    styleUrl: './sgkc032d-slide-tanka-tanka-info.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class Sgkc032dSlideTankaTankaInfoComponent implements OnInit, OnDestroy {
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;
    /** 画面モード */
    @Input() mode: string;
    /** スライド調整単価情報 */
    @Input() slideadjustmentunitpriceInfo: SlideadjustmentunitpriceInfo
    /** スライド調整単価基本情報 */
    @Input() slideadjustmentunitpriceBasicInfo: SlideadjustmentunitpriceBasicInfo;
    /** 登録ボタン押下イベント */
    @Output() onClickRegistrationEvent = new EventEmitter<void>();
    /** 取消ボタン押下イベント */
    @Output() onClickDeleteEvent = new EventEmitter<void>();
    /** 承認ボタン押下イベント */
    @Output() onClickApprovalEvent = new EventEmitter<void>();
    /** 算定諸元情報リスト */
    slidecalculationelementsInformationlist: SlidecalculationelementsInfoDto[];

    appearanceMode: String = "fill";
    appearanceModeBet: String = "fill";

    /** 数値入力の最大桁数(読取専用) */
    readonly constNumberCommaMaxLength: number = 9;
    /** 数値入力の最大桁数 */
    numberCommaMaxLength: number = this.constNumberCommaMaxLength;
    /** 検索結果表示リスト */
    displayedColumnsCol: string[] = [
        'slidecalculationelementsItemname',
        'slidecalculationelementsInfo',
    ];

    /** 適用開始年月 */
    applyStartyearmonth: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** 適用終了年月 */
    applyEndyearmonth: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** 適用開始日 */
    applyStartDate: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** 適用終了日 */
    applyEndDate: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** スライド調整単価 */
    slideadjustmentunitprice: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 消費税率 */
    brdCode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** 新旧区分 */
    oldnewdivision: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** 登録情報格納FormGroup */
    slideTankaRegisterInfoForm: UntypedFormGroup = this.fb.group({
        applyStartyearmonth: this.applyStartyearmonth,
        applyEndyearmonth: this.applyEndyearmonth,
        applyStartDate: this.applyStartDate,
        applyEndDate: this.applyEndDate,
        slideadjustmentunitprice: this.slideadjustmentunitprice,
        brdCode: this.brdCode,
        oldnewdivision: this.oldnewdivision,
        items: this.fb.array([]),
    });
    /** 登録ボタン表示フラグFormGroup */
    isRegistVisible: boolean = false;
    /** 取消ボタン表示フラグFormGroup */
    isDeleteVisible: boolean = false;
    /** 承認ボタン表示フラグFormGroup */
    isApproveVisible: boolean = false;

    /** コンストラクタ 
     * @param {UntypedFormBuilder} fb 
     * @param {FormGroupDirective} parent 
     * @param {Router} router
     * @param {ActivatedRoute} route 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
    */
    constructor(private fb: UntypedFormBuilder,
        private parent: FormGroupDirective,
        private router: Router,
        private route: ActivatedRoute,
    ) { }

    /**
     *  初期処理 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    ngOnInit(): void {
        // 単価通知情報を取得
        this.slidecalculationelementsInformationlist = this.slideadjustmentunitpriceInfo.slidecalculationelementsInformationlist;
        const itemsList = this.slideTankaRegisterInfoForm.get('items') as UntypedFormArray;
        // 画面モードに応じて初期値を設定
        if (this.mode === DisplayMode.create) {
            // 適用開始年月日を取得
            const applyStartYearMonth = this.getNextMonth(this.slideadjustmentunitpriceInfo.applyEndyearmonth);
            const applyStartDate = applyStartYearMonth + "01";
            // 適用終了年月日を取得
            const applyEndYearMonth = this.getEndYearMonth(applyStartYearMonth, this.slideadjustmentunitpriceBasicInfo.registrationunit);
            const applyEndDate = this.getEndYearMonthDay(applyEndYearMonth);

            this.slideTankaRegisterInfoForm.controls['applyStartyearmonth'].setValue(applyStartYearMonth);
            this.slideTankaRegisterInfoForm.controls['applyEndyearmonth'].setValue(applyEndYearMonth);
            this.slideTankaRegisterInfoForm.controls['applyStartDate'].setValue(applyStartDate);
            this.slideTankaRegisterInfoForm.controls['applyEndDate'].setValue(applyEndDate);
            this.slideTankaRegisterInfoForm.controls['slideadjustmentunitprice'].setValue("");
            // 単価通知情報の件数分、itemsに追加、項目値に空文字を設定して活性にする
            if (this.slidecalculationelementsInformationlist.length > 0) {
                this.slidecalculationelementsInformationlist.forEach((slideTankaInfo) => {
                    itemsList.push(
                        this.fb.group({
                            slidecalculationelementsCode: [{ value: slideTankaInfo.slidecalculationelementsCode, disabled: true }],
                            slidecalculationelementsItemname: [{ value: slideTankaInfo.slidecalculationelementsItemname, disabled: true }],
                            slidecalculationelementsInfo: [{ value: "", disabled: false }, Validators.required],
                        })
                    );
                });
            }
        } else {
            this.slideTankaRegisterInfoForm.controls['applyStartyearmonth'].setValue(this.slideadjustmentunitpriceInfo.applyStartyearmonth);
            this.slideTankaRegisterInfoForm.controls['applyEndyearmonth'].setValue(this.slideadjustmentunitpriceInfo.applyEndyearmonth);
            this.slideTankaRegisterInfoForm.controls['applyStartDate'].setValue(this.slideadjustmentunitpriceInfo.applyStartDate);
            this.slideTankaRegisterInfoForm.controls['applyEndDate'].setValue(this.slideadjustmentunitpriceInfo.applyEndDate);
            this.slideTankaRegisterInfoForm.controls['slideadjustmentunitprice'].setValue(this.slideadjustmentunitpriceInfo.slideadjustmentunitprice.toFixed(4));
            // 単価通知情報の件数分、itemsに追加
            if (this.slidecalculationelementsInformationlist.length > 0) {
                this.slidecalculationelementsInformationlist.forEach((slideTankaInfo) => {
                    itemsList.push(
                        this.fb.group({
                            slidecalculationelementsCode: [{ value: slideTankaInfo.slidecalculationelementsCode, disabled: true }],
                            slidecalculationelementsItemname: [{ value: slideTankaInfo.slidecalculationelementsItemname, disabled: true }],
                            slidecalculationelementsInfo: [{ value: slideTankaInfo.slidecalculationelementsInfo, disabled: true }, Validators.required],
                        })
                    );
                });
            }
        }

        this.slideTankaRegisterInfoForm.controls['brdCode'].setValue(this.slideadjustmentunitpriceInfo.brdCode);
        this.slideTankaRegisterInfoForm.controls['oldnewdivision'].setValue(this.slideadjustmentunitpriceInfo.oldnewdivision);

        this.parentForm = this.parent.form;
        this.parentForm.addControl('slideTankaRegisterInfoForm', this.slideTankaRegisterInfoForm);

        // 画面モードに応じてフォームとボタンの制御
        if (this.mode === DisplayMode.create) {
            this.slideTankaRegisterInfoForm.get('slideadjustmentunitprice').enable();
            this.isRegistVisible = true;
        } else if (this.mode === DisplayMode.delete) {
            this.isDeleteVisible = true;
        } else if (this.mode === DisplayMode.approve) {
            this.isApproveVisible = true;
        }
    }

    /** 
     * コンポーネント破棄時の処理
     * @membe
     */
    ngOnDestroy(): void {
        if (this.parent.form != null) {
            this.parentForm.clearValidators();
            this.parentForm.updateValueAndValidity();
            this.parent.form.removeControl('slideTankaRegisterInfoForm');
        }
    }

    /** 
     * 貼り付けイベント処理
     * @remark 貼り付けた値をセル単位に分割してitemsに追加
     * @param {ClipboardEvent} event 
     * @param {number} index 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    onInput(event: ClipboardEvent, index: number): void {
        // 登録モードの時のみ行を追加
        if (this.mode === DisplayMode.create) {
            // 貼り付けた値をセル単位に分割
            event.preventDefault();
            const clipboardData = event.clipboardData;
            const pastedData = clipboardData?.getData('text');
            const pastedRows = pastedData?.split('\r\n');
            pastedRows.pop();
            const pastedCells = pastedRows?.map((row) => row.split('\t'));
            // セル単位に分割した値をindex番目の行以降に追加
            if (pastedCells) {
                pastedCells.forEach((cells, i) => {
                    // itemsの長さを超えないようにチェック
                    if (index + i >= this.items.length) {
                        // ループを終了
                        return;
                    }
                    // セル単位に分割した値をitemsのindex番目の行以降の項目値に追加
                    this.items.at(index + i).patchValue({ slidecalculationelementsInfo: cells[0] });
                });
            }
        }
    }

    /** 
     * 戻るボタン押下処理 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
    */
    goToPrevious(): void {
        this.router.navigate(['/sgkc/sgkc031d', {
            mode: this.route.snapshot.paramMap.get('backmode'),// 戻る用画面モードコード
        }])
    }

    /** 
     * 登録ボタン押下処理 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    onClickRegistration(): void {
        this.onClickRegistrationEvent.emit();
    }

    /** 
     * 承認ボタン押下処理 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    onClickApproval(): void {
        this.onClickApprovalEvent.emit();
    }

    /** 
     * 取消ボタン押下処理 
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    onClickDelete(): void {
        this.onClickDeleteEvent.emit();
    }

    /** 
     * 入力項目のフォーカスアウトイベント処理
     * @remark 入力項目の前後の空白を削除し小数点以下4桁まで表示、小数部4桁以上のときそのまま表示
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    onBlurNumber(): void {
        // 画面入力項目を取得、前後の空白を削除
        let targetMoney: string = this.parentForm.get('slideTankaRegisterInfoForm.slideadjustmentunitprice').value.trim();
        if (targetMoney) {
            let numerTransValue = Number(targetMoney);
            // 数値のとき処理を実行
            if (!isNaN(numerTransValue)) {
                // 小数点以下の桁数を取得
                let decimalPlaces = (targetMoney.split('.')[1] || '').length;
                // 小数部が4桁以下のとき4桁まで表示、それ以上のときそのまま表示
                if (decimalPlaces <= 4) {
                    targetMoney = numerTransValue.toFixed(4);
                } else {
                    targetMoney = targetMoney;
                }
            }
        }
        setTimeout(() => {
            this.parentForm.get('slideTankaRegisterInfoForm.slideadjustmentunitprice').setValue(targetMoney);
        }, 1);
    }

    /** 
     * 翌月取得処理
     * @param {string} yearMonth 
     * @returns {string} 次の年月(YYYYMM形式)
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    getNextMonth(yearMonth: string): string {
        const year = parseInt(yearMonth.substring(0, 4), 10);
        const month = parseInt(yearMonth.substring(4, 6), 10);

        const date = new Date(year, month - 1); // JavaScriptの月は0から始まる
        date.setMonth(date.getMonth() + 1);

        const nextYear = date.getFullYear();
        const nextMonth = ('0' + (date.getMonth() + 1)).slice(-2); // 月を2桁にする

        return `${nextYear}${nextMonth}`;
    }

    /** 
     * 適用終了年月取得処理
     * @param {string} startYearMonth 
     * @param {string} registrationUnit 
     * @returns {string} 適用終了年月(YYYYMM形式)
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    getEndYearMonth(startYearMonth: string, registrationUnit: string): string {
        const year = parseInt(startYearMonth.substring(0, 4), 10);
        const month = parseInt(startYearMonth.substring(4, 6), 10);

        const date = new Date(year, month - 2 + Number(registrationUnit));

        const endYear = date.getFullYear();
        const endMonth = ('0' + (date.getMonth() + 1)).slice(-2);

        return `${endYear}${endMonth}`;
    }

    /** 
     * 適用終了年月の翌月一日を取得
     * @param {string} endYearMonth 
     * @returns {string} 適用終了年月(YYYYMM形式)
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    getEndYearMonthDay(endYearMonth: string): string {
        const year = parseInt(endYearMonth.substring(0, 4), 10);
        const month = parseInt(endYearMonth.substring(4, 6), 10);
        
        // 翌月を取得
        const date = new Date(year, month, 1);

        const endYear = date.getFullYear();
        const endMonth = ('0' + (date.getMonth() + 1)).slice(-2);

        // 翌月一日を返却
        return `${endYear}${endMonth}01`;
    }

    /** 
     * items FormArrayのゲッター
     * @returns {FormArray} items FormArray
     * @memberof Sgkc032dSlideTankaTankaInfoComponent
     */
    get items(): FormArray {
        return this.slideTankaRegisterInfoForm.get('items') as FormArray;
    }
}